import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function FeeAccountIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <>
        <path d="M12.293 6.293a1 1 0 0 1 1.676.957L13 11H16a1 1 0 0 1 .707 1.707l-5 5a1 1 0 0 1-1.676-.957L11 13H8a1 1 0 0 1-.707-1.707z" />
        <path
          fillRule="evenodd"
          d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18"
          clipRule="evenodd"
        />
      </>
    </Icon>
  );
}

FeeAccountIcon.displayName = 'FeeAccountIcon';
